const paletteBlue = {
  primary: {
    main: "#258EBF",
    light: "#D7F0FF",
    dark: "#1E7299",
    contrastText: "#fff",
  },
  secondary: {
    main: "#6BC4F8",
    light: "#D7F0FF",
    dark: "#177FC2",
    contrastText: "#fff",
  },
};

export default paletteBlue;
